import * as React from 'react';
import FreehandPenIconImage from './FreehandPenIconImage';
import ToolIcon from '../../common/ToolIcon';

interface FreehandPenToolIconProps {
  readonly buttonNumber: number;
  readonly title?: string;
  readonly style?: React.CSSProperties;
  readonly svgStyle?: React.CSSProperties;
}

const FreehandPenToolIcon: React.SFC<
  FreehandPenToolIconProps
> = React.memo((props) => {
  const { buttonNumber, title, style, svgStyle } = props;

  return (
    <ToolIcon title={title} style={style}>
      <FreehandPenIconImage buttonNumber={buttonNumber} svgStyle={svgStyle} />
    </ToolIcon>
  );
});

export default FreehandPenToolIcon;
